var _style, _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1500 1500",
    style: {
      enableBackground: "new 0 0 1500 1500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#39B54A;}\r\n\t.st1{fill:#39B54A;stroke:#000000;stroke-width:18;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st2{fill:#39B54A;stroke:#000000;stroke-width:10;stroke-linecap:round;stroke-linejoin:round;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "SVGID",
    className: "st0",
    cx: 750.9,
    cy: 750,
    r: 750
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 750.9,
    cy: 750,
    r: 750
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M570.2,803.7c-5.4-0.7-32.8-3-32.8-3s138.2-126.5,199.8-181.6c12.6-11.2,19.9-10,31.7,0.4 c61.8,54.9,199.2,181.8,199.2,181.8s-27.2,1.7-32.9,2.4c0,32.1,0,69,0,101c0.1,34.7-0.3,69.3,0.5,104c0.4,15.1-5.4,20.8-20.2,20.5 c-26.1-0.6-52.3-0.7-78.5,0.1c-12.8,0.4-17.2-4.2-16.9-16.8c0.6-31.6-0.3-63.3,0.5-94.9c0.4-14.4-4.5-19.2-18.9-18.8 c-32.2,0.9-64.5,1-96.7,0c-14.9-0.5-20.6,4-20.1,19.4c0.9,31.6,0,63.2,0.6,94.9c0.2,11.6-3.4,16.4-15.6,16.1 c-26.7-0.7-53.5-0.7-80.3-0.1c-15.3,0.3-19.8-6.4-19.7-21c0.6-59.6,0.2-119.2,0.2-178.8L570.2,803.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1008.3,625.7c-29.7-39.2-51.6-84.3-90.8-116.2c-10-8.1-20.6-8.1-32.1-1c-4.8,3-12.2,4.4-17.7,3.1 c-27.1-6.6-54.1-14-80.9-21.9c-5-1.5-9-6.3-13.5-9.6c5.3-2.9,10.5-7.9,16-8.3c66.8-5.4,130.4,9.5,192.9,31.5 c5.2,1.8,10.2,4.1,15.3,5.9c45.4,15.5,71,45.5,80.4,94c9.7,50.2,32,95.7,78.8,124.9c-11.8,31.6-22.8,62.4-35.2,92.7 c-1.7,4.2-9.8,8.5-14.6,8.2c-56.8-3.5-109.7-45.6-124.2-100.2c-12-45.2-31.9-86.4-56.7-125.7c-13.6-21.5-26.1-43.8-37.4-66.7 c-2.9-5.9,0.9-15.2,1.7-22.9c7.7,0.8,18.3-1.3,22.7,2.9c16.1,15.6,31,32.3,44.7,50c15.9,20.4,30.1,42.2,45,63.3L1008.3,625.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1237.8,742c-15.7,38.7-29.7,74.9-45.4,110.4c-2.6,6-11.9,9.3-18.5,13c-2.3,1.3-6,0.2-9-0.1 c-37.2-3-42.1-10.6-28.9-45.6c11-29,22.2-57.8,32.8-86.9c5.6-15.4,15.4-19.8,29.7-12.7C1211.5,726.6,1223.9,734.2,1237.8,742z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M882.6,539.7c-82-14.8-107.7-25.7-106.4-46.6c32.3,8.8,64.3,16.9,95.8,26.7 C876.4,521.1,878.2,530.8,882.6,539.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M893,573.5c-21.6-7.4-43.5-14-64.6-22.7c-9-3.7-16.3-11.5-24.4-17.4c1.1-1.9,2.3-3.8,3.4-5.6 c24.4,6.1,48.9,11.7,73.1,18.5c9.8,2.8,16.1,19,12,26.7L893,573.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M892.4,573l23.9,22.7l-3.1,4.3c-25.3-6.8-51.8-11.1-70.7-31.7l1.8-4.5c16.3,3.3,32.5,6.5,48.7,9.7L892.4,573z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M493.6,625.7c29.7-39.2,51.6-84.3,90.8-116.2c10-8.1,20.6-8.1,32.1-1c4.8,3,12.2,4.4,17.7,3.1 c27.1-6.6,54.1-14,80.9-21.9c5-1.5,9-6.3,13.5-9.6c-5.3-2.9-10.5-7.9-16.1-8.3c-66.8-5.4-130.4,9.5-192.8,31.5 c-5.2,1.8-10.1,4.1-15.3,5.9c-45.4,15.5-71,45.5-80.4,94c-9.7,50.2-32,95.7-78.8,124.9c11.8,31.6,22.9,62.4,35.2,92.7 c1.7,4.2,9.8,8.5,14.6,8.2c56.8-3.5,109.7-45.6,124.2-100.2c12-45.2,31.9-86.4,56.7-125.7c13.6-21.6,26.1-43.8,37.4-66.7 c2.9-5.9-1-15.2-1.7-22.9c-7.7,0.8-18.3-1.3-22.7,2.9c-16.1,15.6-31,32.3-44.7,50c-15.9,20.4-30.1,42.2-45,63.3L493.6,625.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M264,742c15.7,38.7,29.7,74.9,45.4,110.4c2.6,6,11.9,9.3,18.5,13c2.3,1.3,6,0.2,9-0.1 c37.2-3,42.1-10.6,28.9-45.6c-11-29-22.2-57.8-32.8-86.9c-5.6-15.4-15.4-19.8-29.7-12.7C290.4,726.6,278,734.2,264,742z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M619.2,539.7c82-14.8,107.7-25.7,106.4-46.6c-32.3,8.8-64.3,16.9-95.8,26.7 C625.5,521.1,623.7,530.8,619.2,539.7z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M608.9,573.5c21.6-7.4,43.5-14,64.6-22.7c9-3.7,16.3-11.5,24.4-17.4c-1.1-1.9-2.3-3.8-3.4-5.6 c-24.4,6.1-48.9,11.7-73.1,18.5c-9.8,2.8-16.1,19-12,26.7L608.9,573.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M609.4,573l-23.9,22.7l3.1,4.3c25.3-6.8,51.8-11.1,70.7-31.7l-1.8-4.5c-16.2,3.3-32.5,6.5-48.7,9.7L609.4,573z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.b0c13bd3990e039033e9ad5d9a3e62a8.svg";
export { ForwardRef as ReactComponent };